const pending_transactions = [
    "Receiver",
    "Role",
    "Amount (Rs)",
    "Payment Type",
    "Actions"
  ];
  
  
  const headers_enums = {
    pending_transactions: 0,
  };
  
  export {
    pending_transactions,
    headers_enums,
  };
  